import { render, staticRenderFns } from "./ImageMediaPrintGrid.vue?vue&type=template&id=651b2d12&scoped=true"
import script from "./ImageMediaPrintGrid.vue?vue&type=script&lang=js"
export * from "./ImageMediaPrintGrid.vue?vue&type=script&lang=js"
import style0 from "./ImageMediaPrintGrid.vue?vue&type=style&index=0&id=651b2d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b2d12",
  null
  
)

export default component.exports